module.exports = __webpack_public_path__ + "img/icon-tuanyou.69de9785.png";